// extracted by mini-css-extract-plugin
module.exports = {"header__search":"SearchBlock_header__search__3f1_p"};